export enum Country {
  Canada = 'CA',
  UnitedStates = 'US',
}
